import { isPermitRockstarDomain } from "../utils/domainUtils";

export const protectedPaths = {
  userSession: [
    {
      path: "/dashboard",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/permits/create",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/selectcounties",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/defaults",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/permits/my-permits",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/permits/subuser-permits",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user"],
    },
    {
      path: "/permits/customers-packages",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/permits/invitations",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    //!
    {
      path: "/custom-documents/sign",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/custom-documents/noc",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/custom-documents/prepared-docs",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    //!
    {
      path: "/profilesettings",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/contractors",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/payment",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/subusers",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/branches",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/subscription",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/contact",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["user", "admin"],
    },
    {
      path: "/admin/overview",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/session-usage",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/customers",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/sales",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/notaries",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/tasks",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/licenses",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/admin/management",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    {
      path: "/form-uploader",
      cookie: "__nocCreator__u_sid",
      socket: false,
      roles: ["formDigUser"],
    },
    {
      path: "/admin/email",
      cookie: "__nocCreator__u_sid",
      socket: true,
      roles: ["admin"],
    },
    // Conditionally include admin/reports route based on domain
    ...(isPermitRockstarDomain()
      ? []
      : [
          {
            path: "/admin/reports",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/admin/forms-management",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          //^ NEW PP UI
          {
            path: "/pp/photos",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/photos/capture",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/photos/annotate",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/photos/requirements",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/submissions",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/submissions/new",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/submissions/:id",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/workbench/:id",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/inspections",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/inspections/:permitId",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/inspections/templates",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/finance",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/finance/payouts",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/finance/statements",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/messaging",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/messaging/:threadId",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/notifications",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/settings",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/settings/city-reporting",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/settings/digital-signature",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/inspections/:permitId/edit",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/submissions/:submissionId/stamp",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/submissions/:submissionId/preview",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/contractor",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/contractor/permits",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/contractor/permits/:id/inspections",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/contractor/uploads",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
          {
            path: "/pp/contractor/messaging",
            cookie: "__nocCreator__u_sid",
            socket: true,
            roles: ["admin"],
          },
        ]),
  ],
  subUserSession: [
    {
      path: "/dashboard",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/permits/create",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/permits/my-permits",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/permits/invitations",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/selectcounties",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/defaults",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/permits/internal",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    //!
    {
      path: "/custom-documents/sign",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/custom-documents/noc",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/custom-documents/prepared-docs",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    //!

    {
      path: "/profilesettings",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/payment",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/subscription",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
    {
      path: "/contact",
      cookie: "__nocCreator__su_sid",
      socket: true,
      roles: ["subUser"],
    },
  ],
  notarySession: [
    {
      path: "/notary/dashboard",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
    {
      path: "/notary/organization",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
    {
      path: "/notary/finalize",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
    {
      path: "/notary/history",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
    {
      path: "/notary/ipen",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
    {
      path: "/notary/contact",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
    {
      path: "/notary/settings",
      cookie: "__nocCreator__n_sid",
      socket: true,
      roles: ["notary"],
    },
  ],
  guestSession: [
    {
      path: "/record/signee/register",
      cookie: "__nocCreator__g_sid",
      socket: true,
      roles: ["guest"],
    },
    {
      path: "/notary/signee/register",
      cookie: "__nocCreator__g_sid",
      socket: true,
      roles: ["guest"],
    },
    {
      path: "/signee/manage",
      cookie: "__nocCreator__g_sid",
      socket: true,
      roles: ["guest"],
    },
  ],
  privateProviderSession: [
    {
      path: "/dashboard",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/permits/create",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/selectcounties",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/defaults",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/permits/my-permits",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/permits/invitations",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    // {
    //   path: "/custom-documents/sign",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/custom-documents/noc",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/custom-documents/prepared-docs",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    {
      path: "/profilesettings",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    // {
    //   path: "/contractors",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    {
      path: "/privateProvider/contractors",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },

    {
      path: "/payment",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/subusers",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/subscription",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/contact",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/privateProvider/dashboard",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/privateProvider/create-permit",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    {
      path: "/privateProvider/profile",
      cookie: "__nocCreator__pp_sid",
      socket: true,
      roles: ["privateProvider"],
    },
    //! New PP UI
    // {
    //   path: "/pp/photos",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/photos/capture",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/photos/annotate",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/photos/requirements",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/submissions",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/submissions/new",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/submissions/:id",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/workbench/:id",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/inspections",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/inspections/:permitId",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/inspections/templates",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/finance",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/finance/payouts",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/finance/statements",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/messaging",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/messaging/:threadId",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/notifications",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/settings",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/settings/city-reporting",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/settings/digital-signature",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/inspections/:permitId/edit",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/submissions/:submissionId/stamp",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/submissions/:submissionId/preview",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/contractor",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/contractor/permits",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/contractor/permits/:id/inspections",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/contractor/uploads",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
    // {
    //   path: "/pp/contractor/messaging",
    //   cookie: "__nocCreator__pp_sid",
    //   socket: true,
    //   roles: ["privateProvider"],
    // },
  ],
};
